import React, { useState, useEffect, useCallback, useMemo, useRef, useImperativeHandle } from 'react';
import { Spin, Tooltip } from 'antd';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import classnames from 'classnames';
import { apiHolder as api, apis, mailPerfTool, } from 'api';
import { BackToTopNewIcon } from '@web-common/components/UI/Icons/icons';
import '../../mailBox.scss';
import '../MailList/index.scss';
import MailList from '../MailList/MailList';
import MailListLong from '../MailList/MailListLong';
import MailWrap from './mailListWrap';
import useState2RM from '../../hooks/useState2ReduxMock';
import useMailStore from '../../hooks/useMailStoreRedux';
import { promiseIsTimeOut, getMainAccount, openMailInWinow, } from '../../util';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { MailActions, useActions, useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { FLOLDER } from '../../common/constant';
import FilterTab from './filterElement';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import useThrottleForEvent from '../../hooks/useThrottleForEvent';
const MailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const MailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const systemApi = api.api.getSystemApi();
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const performanceApi = api.api.requireLogicalApi(apis.performanceImpl);
import useListDiffFouceRender from './useListDiffFouceRender';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import { getIn18Text } from 'api';
import { createAccountEmailKey } from '@web-common/components/util/contact';
import { refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import DetailCardSender from '@web-mail/components/DetailCardSender/DetailCardSender';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const ListFail = (props) => {
    const { loading = false, onRefresh = () => { } } = props;
    return (React.createElement("div", { className: "m-list" },
        React.createElement("div", { className: "m-list-empty" },
            React.createElement("div", { className: "empty" }, getIn18Text('JIAZAISHIBAI')),
            loading ? (React.createElement(Spin, { indicator: React.createElement(LoadingOutlined, { style: { fontSize: 24 }, spin: true }) })) : (React.createElement("div", { className: "refresh", onClick: onRefresh }, getIn18Text('ZHONGXINJIAZAI'))))));
};
const ListEmpty = (props) => {
    const { name = '', onRefresh = () => { }, showLogo = true, btnRender, otherRender } = props;
    const Btn = useMemo(() => {
        if (typeof btnRender === 'function') {
            return btnRender();
        }
        else {
            return React.createElement(React.Fragment, null, getIn18Text('SHUAXIN'));
        }
    }, [btnRender]);
    const otherRenderDom = useMemo(() => {
        if (typeof otherRender === 'function') {
            return otherRender();
        }
        else {
            return null;
        }
    }, [otherRender]);
    return (React.createElement("div", { className: "m-list" },
        React.createElement("div", { className: "m-list-empty" },
            showLogo && React.createElement("div", { className: "sirius-empty sirius-empty-doc", style: { marginBottom: '20px' } }),
            React.createElement("div", { className: "empty" }, name),
            React.createElement("div", { className: "refresh", onClick: onRefresh }, Btn),
            otherRenderDom ? React.createElement("div", null, otherRenderDom) : null)));
};
const ListBackTop = (props) => {
    const { style, onClick } = props;
    return (React.createElement("div", { style: style, className: classnames(['back-top-wrapper']) },
        React.createElement(Tooltip, { title: getIn18Text('HUIDAODINGBU'), mouseEnterDelay: 1, mouseLeaveDelay: 0.15 },
            React.createElement(BackToTopNewIcon, { onClick: onClick, style: { cursor: 'pointer' } }))));
};
const MailListWrap = React.forwardRef((props, ref) => {
    const { isLeftRight } = props;
    const listRef = useRef();
    useImperativeHandle(ref, () => listRef.current, []);
    const innerProps = useMemo(() => {
        return Object.assign(Object.assign({}, props), { ref: undefined });
    }, [props]);
    return isLeftRight ? React.createElement(MailList, Object.assign({}, innerProps, { ref: listRef })) : React.createElement(MailListLong, Object.assign({}, innerProps, { ref: listRef }));
});
const topCalculated = 300;
const AiMailColumnEntry = (props, ref) => {
    const [mailDataList] = useMailStore('AI_tab_mailDataList', { key: 'mailList', exclude: ['receiver'] });
    const { isLeftRight } = props;
    const isUpDown = false;
    const dispatch = useAppDispatch();
    const [curMenuMailId, setCurMenuMailId] = useState();
    const [listLoading, setListLoading] = useState2RM('AI_tab_listLoading');
    const [scrollTop, setScrollTop] = useState2RM('AI_tab_scrollTop');
    const [mailListMenuVisiable, setMailListMenuVisiable] = useState2RM('AI_tab_mailListMenuVisiable');
    const [refreshLoading, setFreshLoading] = useState2RM('AI_tab_refreshLoading');
    const [selectedMail, setSelectedMail] = useState2RM('AI_tab_selectedMailId');
    const [mailTotal, setMailTotal] = useState2RM('AI_tab_mailTotal');
    const [listLoadIsFail, setListLoadIsFail] = useState2RM('AI_tab_mailListInitIsFailed');
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const moreAccounts = false;
    const [groupCollapseKeys, setGroupCollapseKeys] = useState2RM('AI_tab_groupCollapseKeys');
    const shouldUseRealList = false;
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const reducer = useActions(MailActions);
    const mailIdList = useMemo(() => {
        var _a, _b;
        const list = mailDataList;
        return (_b = (_a = list) === null || _a === void 0 ? void 0 : _a.map(item => item === null || item === void 0 ? void 0 : item.id)) === null || _b === void 0 ? void 0 : _b.join(',');
    }, [mailDataList]);
    const listFouceRender = useListDiffFouceRender(mailDataList, [], false, isLeftRight);
    const mailList = useMemo(() => {
        return mailDataList;
    }, [mailDataList]);
    const havingContent = useMemo(() => {
        return (mailList && mailList.length > 0) || listLoading;
    }, [mailList, listLoading]);
    const showListBackTop = useMemo(() => {
        return scrollTop > topCalculated;
    }, [scrollTop]);
    const mailListRef = useRef();
    const trackMailActiveStart = useCallback((id) => {
        try {
            performanceApi.time({
                statKey: `mail_listclick_content_load_time`,
                statSubKey: id + '',
            });
        }
        catch (e) {
            console.error(e);
        }
    }, []);
    const trackMailActiveStartRef = useCreateCallbackForEvent(trackMailActiveStart);
    let empryFolderTip = useMemo(() => {
        let res = getIn18Text('WENJIANJIA');
        return res + getIn18Text('MAIL_FOLDER_EMPTY_TIP');
    }, []);
    const handleMailDelete = useCallback((id, isThread, params) => {
        dispatch(Thunks.deleteMail({
            id,
            showLoading: params === null || params === void 0 ? void 0 : params.showLoading,
            isScheduleSend: params === null || params === void 0 ? void 0 : params.isScheduleSend,
            detail: params === null || params === void 0 ? void 0 : params.detail,
        }));
    }, []);
    const refreshPage = useCallback((showMessage = true) => {
        return promiseIsTimeOut(dispatch(Thunks.doExtractMailMainAccountFromAI({ refresh: true })), 'pc_refreshPage_timeout', {
            from: 'AiMailColumnEntry',
            showMessage: showMessage,
        });
    }, []);
    const handleMailMove = useCallback((mid, folder) => {
        reducer.showMailMoveModal({
            mailId: mid,
            folderId: folder,
        });
    }, []);
    const listLoadLoading = useRef(false);
    useEffect(() => {
        listLoadLoading.current = false;
    }, [mailIdList]);
    const loadMailListData = useCallback(({ startIndex }, noCache = false) => {
        if (!listLoadLoading.current) {
            listLoadLoading.current = true;
            return dispatch(Thunks.loadMailList({
                startIndex,
                noCache,
            })).finally(() => {
                listLoadLoading.current = false;
            });
        }
        return Promise.resolve();
    }, []);
    const openNewWindow = useCallback((ids) => {
        if (ids && ids.length) {
            dispatch(Thunks.openMailInNewWindow(ids[0]));
        }
    }, []);
    const handleMailActive = useCallback((id, index, data) => {
        trackMailActiveStartRef(id);
        const item = data;
        if (item && item.entry && item.entry.id) {
            setSelectedMail({
                id: id,
                accountId: '',
            });
        }
    }, [isLeftRight, isUpDown]);
    const handleMailDoubleClick = useCallback((mail) => {
        const { isThread, _account, isTpMail, owner } = mail;
        mailPerfTool.mailContent('window', 'start', { isThread: !!isThread });
        if (systemApi.isElectron() && mail.entry.folder === FLOLDER.DRAFT) {
            MailApi.doEditMail(mail.id, { draft: true, _account: mail === null || mail === void 0 ? void 0 : mail._account });
        }
        else {
            openMailInWinow(mail);
        }
    }, []);
    const debouceHandleMailDoubleClick = useDebounceForEvent(handleMailDoubleClick, 400, {
        leading: true,
        trailing: false,
    });
    const handleGroupCollapse = useCallback((id, isCollapse) => {
        setGroupCollapseKeys(list => {
            if (isCollapse) {
                return [...new Set([...list, id])];
            }
            else {
                return list.filter(item => item !== id);
            }
        });
    }, []);
    const listCommonAttr = useMemo(() => {
        const summary = null;
        const desc = null;
        return {
            isLeftRight,
            isUpDown,
            activeId: [],
            refreshPage,
            isSearching: false,
            onDoubleClick: debouceHandleMailDoubleClick,
            onActiveInWindow: openNewWindow,
            listLoading,
            hkDisabled: currentTabId !== '-1' && currentTabId !== '-1/-1',
            mailCardSummary: summary,
            mailCardDesc: desc,
            beforeSelected: (ids, activeIds, curId) => {
            },
            onSelect: (ids, activeIds, curId) => {
            },
            onUnSelect: (ids, activeIds, curId) => {
            },
            onActive: handleMailActive,
            onContextMenu: (key, data, index, event) => {
                setMailListMenuVisiable(true);
                if (Array.isArray(data)) {
                    setCurMenuMailId(data === null || data === void 0 ? void 0 : data.map(item => item === null || item === void 0 ? void 0 : item.id));
                }
                else {
                    setCurMenuMailId([data === null || data === void 0 ? void 0 : data.id]);
                }
            },
            from: process.env.BUILD_ISEDM || navigateVersion ? DetailCardSender : null,
        };
    }, [listLoading, handleMailActive, isLeftRight, isUpDown, currentTabId, navigateVersion]);
    const emailIdMap = useAppSelector(state => state.contactReducer.emailIdMap);
    const contactMap = useAppSelector(state => state.contactReducer.contactMap);
    const customerMap = useAppSelector(state => state.contactReducer.customerMap);
    useEffect(() => {
        var _a;
        if (process.env.BUILD_ISEDM || navigateVersion) {
            const requestEmails = [];
            mailDataList.forEach(m => {
                var _a, _b, _c;
                const { receiver, _account = getMainAccount() } = m || {};
                const accountAlias = ((_b = (_a = systemApi.getCurrentUser(m === null || m === void 0 ? void 0 : m._account)) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.accountAlias) || [];
                const accountAliasArray = Array.isArray(accountAlias) ? accountAlias : [accountAlias];
                const senderEmail = contactApi.doGetModelDisplayEmail((_c = m === null || m === void 0 ? void 0 : m.sender) === null || _c === void 0 ? void 0 : _c.contact);
                const isSend = m
                    ? accountAliasArray.some(account => accountApi.getIsSameSubAccountSync(account, senderEmail)) || accountApi.getIsSameSubAccountSync(senderEmail, m._account)
                    : false;
                if (isSend) {
                    const emails = receiver === null || receiver === void 0 ? void 0 : receiver.map(item => contactApi.doGetModelDisplayEmail(item.contact)).filter(Boolean);
                    if (emails && emails.length) {
                        emails.forEach(email => {
                            const accountEmailKey = createAccountEmailKey(email, _account);
                            const contactId = emailIdMap[accountEmailKey];
                            if (contactId) {
                                const contactModel = contactMap[contactId];
                                const customerModel = customerMap[contactId];
                                if (!contactModel && !customerModel) {
                                    requestEmails.push(email);
                                }
                            }
                            else {
                                requestEmails.push(email);
                            }
                        });
                    }
                }
            });
            if (!!requestEmails.length) {
                const account = ((_a = mailDataList[0]) === null || _a === void 0 ? void 0 : _a._account) || getMainAccount();
                refreshContactDataByEmails({ [account]: [...new Set(requestEmails)] }, new Map());
            }
        }
    }, [mailIdList]);
    const throttleOnScroll = useThrottleForEvent((param) => {
        setScrollTop(param.scrollTop);
    }, 400, {
        leading: true,
        trailing: true,
    });
    const handleMailListDelete = useCallback((idList) => {
        if (idList && idList.length) {
            dispatch(Thunks.deleteMailFromHotKey(idList.length === 1 ? idList[0] : idList));
        }
    }, []);
    const handleListInsufficientHeight = useDebounceForEvent(() => {
        if (mailDataList.length < mailTotal && !shouldUseRealList) {
            loadMailListData({
                startIndex: mailDataList.length,
            });
        }
    }, 800, {
        leading: false,
        trailing: true,
    });
    const mailListElement = useCallback((config) => {
        const { height = 0, width = 0 } = config || {};
        const commonAttr = listCommonAttr;
        return (React.createElement(MailListWrap, Object.assign({ ref: mailListRef }, commonAttr, { useRealList: shouldUseRealList, realListClassName: "mail-real-list", realListPager: false, scrollTop: scrollTop, listHeight: height, listWidth: width, data: mailDataList, rowCount: mailTotal, loadMoreRows: loadMailListData, notice: false, onScroll: throttleOnScroll, listFouceRender: listFouceRender, onDelete: handleMailListDelete, useLeftRightHotKey: isUpDown, isRefresh: false, onContentInsufficientHeight: handleListInsufficientHeight, noMoreRender: undefined, onGroupCollapse: handleGroupCollapse, groupCollapse: groupCollapseKeys, isAIMailTab: true, showCheckbox: false })));
    }, [
        scrollTop,
        listCommonAttr,
        mailIdList,
        mailTotal,
        loadMailListData,
        isLeftRight,
        isUpDown,
        listFouceRender,
        shouldUseRealList,
        groupCollapseKeys,
    ]);
    const ListFailCom = useMemo(() => (React.createElement(ListFail, { loading: refreshLoading, onRefresh: () => {
            setListLoadIsFail(false);
            setListLoading(true);
            refreshPage(false);
        } })), [refreshLoading]);
    const ListEmptCom = useMemo(() => {
        const otherRender = null;
        return (React.createElement(ListEmpty, { name: empryFolderTip, showLogo: !isLeftRight && !isUpDown, onRefresh: () => {
                setFreshLoading(true);
                refreshPage(false);
            }, otherRender: otherRender }));
    }, [empryFolderTip, isLeftRight, isUpDown]);
    const ListTipCom = useMemo(() => (listLoadIsFail ? ListFailCom : ListEmptCom), [listLoadIsFail, ListFailCom, ListEmptCom]);
    const MailListCom = useCallback((config) => (React.createElement("div", { className: "m-list" },
        React.createElement(MailWrap, { visible: mailListMenuVisiable, setVisible: setMailListMenuVisiable, isAdvancedSearch: false, isSearching: false, onMove: handleMailMove, onDelete: handleMailDelete, activeMailId: curMenuMailId, openNewWindow: openNewWindow, moreAccounts: moreAccounts }, mailListElement(config)))), [mailListElement, mailListMenuVisiable, curMenuMailId]);
    const autoSizeElement = useMemo(() => {
        return (React.createElement("div", { style: { width: '100%', flex: '1', minHeight: 0 } },
            React.createElement(AutoSizer, { style: { width: '100%', height: '100%' } }, ({ height, width }) => {
                let max = 1000;
                try {
                    max = (window === null || window === void 0 ? void 0 : window.innerHeight) || 1000;
                }
                catch (e) {
                    console.log('[ window.innerHeight Error]', e);
                }
                const resHeight = height > max ? max : height;
                const listElement = havingContent ? MailListCom({ width, height: resHeight }) : ListTipCom;
                return listElement;
            })));
    }, [havingContent, MailListCom, ListTipCom, shouldUseRealList]);
    const FilterTabElement = useMemo(() => {
        return React.createElement(FilterTab, null);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "m-list-container ant-allow-dark", style: { height: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' } }, autoSizeElement),
        showListBackTop && (React.createElement(ListBackTop, { style: { bottom: shouldUseRealList ? '100px' : '' }, onClick: () => {
                setScrollTop(0);
            } }))));
};
export default AiMailColumnEntry;
